<div class="modal-header">
  <button type="button" class="btn-close" (click)="close()" aria-label="Close">
    <i class="feather x"></i>
  </button>
  <h4 class="modal-title" id="myModalLabel">Create eSignature Request</h4>
</div>

<div class="modal-body" [ngSwitch]="currentStep">
  <ng-container *ngSwitchCase="'SELECT_FILE'">
    <label
      class="drag-and-drop-upload"
      appDragDrop
      (onFileDropped)="fileChange($event)"
    >
      <h3>Drag & Drop your files or click here to select</h3>
      <input
        #fileUpload
        accept=".pdf,.doc,.docx,.pptx,.ppt,.xls,.xlsx,.csv,.txt,.rtf,.html,.zip,.mp3,.wma,.mpg,.flv,.avi,.jpg,.jpeg,.png,.gif,.ofx,.qbo,.iif"
        type="file"
        (change)="fileChange($event.target.files)"
        multiple
      />
    </label>
    <div class="upload-wrapper" [ngClass]="{ 'border-top': has_file }">
      <div
        class="file-upload-preview generic {{ selectedFile.ext }} item{{ i }}"
        *ngFor="let selectedFile of selectedFiles; let i = index"
      >
        <div class="file-name">{{ selectedFile.filename }}</div>
        <button class="remove-uploaded-file" (click)="removeFile(i)">
          <i class="feather x"></i>
        </button>
      </div>
    </div>
  </ng-container>

  <ng-container *ngSwitchCase="'SELECT_RECIPIENT'">
    <div class="form-group">
      <label for="request_name">Document Name</label>
      <input
        [(ngModel)]="requestName"
        type="text"
        id="request_name"
        class="form-control"
        placeholder="Document Name"
      />
    </div>
    <div class="form-group">
      @if (conversationClients.length > 0) {
        <label for="request_name">Recipients</label>
        <label
          *ngFor="let client of conversationClients"
          class="d-flex"
          style="gap: 8px"
        >
          <input
            [(ngModel)]="client.selected"
            type="checkbox"
            [checked]="client.selected"
          />
          <div class="avatar avatar-24">
            <div
              class="photo"
              *ngIf="client.picture_url"
              style="background-image: url('{{ client.picture_url }}')"
            ></div>
            <div class="initials" initials [name]="client.full_name"></div>
          </div>
          <span class="notify-username" title="{{ client.full_name }}">{{
            client.full_name
          }}</span>
        </label>
      } @else {
        <label class="no-client-users">
          There are no client users in this workspace, so eSignature request
          cannot be sent.
        </label>
      }
    </div>
    <div class="form-group">
      <b>Note:</b> SignWell is our partner for eSignatures. There is a small fee
      for each eSignature request that you send. Your client(s) will get an
      email that comes from “{{ requesterName }} via SignWell” to electronically
      sign the document.
    </div>
    <!-- <div class="form-group">
      <label for="recipients">Additional recipients</label>
      <input
        [(ngModel)]="additionalRecipients"
        type="text"
        id="recipients"
        class="form-control"
        placeholder="Add multiple e-mails separating by comma"
        disabled="true"
      />
    </div> -->
  </ng-container>

  <ng-container *ngSwitchCase="'GET_EMBEDDED_DOCUMENT'">
    <!-- <iframe [src]="embeddedUrl | safeUrl"></iframe> -->
  </ng-container>

  <ng-container *ngSwitchCase="'SENT'">
    <!-- <h1>Your recipients will receive the sign request soon enough</h1> -->
  </ng-container>
</div>
<div class="modal-footer">
  <div class="row">
    <div class="col-sm-6 text-left">
      <button type="button" class="btn btn-default" (click)="bsModalRef.hide()">
        Cancel
      </button>
    </div>
    <div class="col-sm-6">
      <!-- <button type="button" class="btn btn-primary" (click)="upload()">
        <span>{{ !formdataOnly ? "Upload files" : "Add files" }}</span>
      </button> -->
      <button
        type="button"
        class="btn btn-primary"
        *ngIf="currentStepIdx > 0 && currentStepIdx !== 3"
        (click)="previous()"
      >
        <span>Previous</span>
      </button>
      <button
        type="button"
        class="btn btn-primary"
        [disabled]="!canGoNext()"
        (click)="next()"
        *ngIf="currentStepIdx !== 3"
      >
        <span>Next</span>
      </button>
      <button
        type="button"
        class="btn btn-primary"
        *ngIf="currentStepIdx === 3"
        (click)="bsModalRef.hide()"
      >
        <span>Finish</span>
      </button>
    </div>
  </div>
</div>

<div class="upload-loading" *ngIf="isLoading">
  <div>
    <img src="assets/img/ajax-loader.gif" alt="Loading" /> <br />Loading...
  </div>
</div>
